import getThisMediaSettings from './this-media-settings';
import getAllMediaSettings from './all-media-settings';
import { getThisMediaAppearanceSettings, getAllMediaAppearanceSettings } from './appearance';

export default {
  getThisMediaSettings,
  getAllMediaSettings,
  getThisMediaAppearanceSettings,
  getAllMediaAppearanceSettings,
};
